import { useState } from 'react';

import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import { useTranslation } from 'react-i18next';

import AlertMessage from '../../../components/elements/alert-message/AlertMessage';
import Loading from '../../../components/elements/loading/Loading';
import FileManager from '../../../components/page-sections/file-manager/FileManager.jsx';
import Breadcrumbs from '../../../components/sections/breadcrumbs/Breadcrumbs';
import SelectDropdown from '../../../components/sections/select-dropdown/SelectDropdown';
import TitlePanel from '../../../components/sections/title-panel/TitlePanel';
import { DEFAULT_SUBSCRIPT_NUMBER } from '../../../constants';
import { useSolrInstance } from '../../../contexts/SolrContext';
import { isSolrCloud, sentenceCase } from '../../../utils/utils';

// Constants
const HOME_PATH = '/var';
const BASE_FOLDER_CHAIN = [{ id: 'base_file', name: 'solr', isDir: true }];

// Simple utility wrapper to be able to access the FileManager context
const SolrFileManagerPage = () => {
  const { instance, loading } = useSolrInstance();
  const { t } = useTranslation();

  const [subscript, setSubscript] = useState(DEFAULT_SUBSCRIPT_NUMBER);

  const handleSubscriptChange = (newSubscript) => setSubscript(newSubscript);

  if (loading) return <Loading />;

  return instance ? (
    <Container>
      <Breadcrumbs instanceName={instance.name} />
      <TitlePanel title={t('fileManager', { ns: 'titles' })} />
      <Box sx={{ mb: 2 }}>
        {isSolrCloud(instance.type) && (
          <SelectDropdown
            title={sentenceCase(
              t('selected', {
                ns: 'instance',
                text: t('instanceNode', { ns: 'instance' }),
              })
            )}
            selectList={instance.instances}
            value={subscript}
            isControlled={true}
            valueKey="subscriptNumber"
            nameKey="subscriptNumber"
            prefix={instance.name}
            onChange={handleSubscriptChange}
          />
        )}
      </Box>
      <FileManager
        basePath={HOME_PATH}
        baseFolderChain={BASE_FOLDER_CHAIN}
        subscript={subscript}
      />
    </Container>
  ) : (
    <AlertMessage
      severity="error"
      message={sentenceCase(
        t('loading', {
          ns: 'errors',
          content: t('requestedFileList', { ns: 'instance' }),
        })
      )}
    />
  );
};

export default SolrFileManagerPage;
